import { Capacitor, registerPlugin } from "@capacitor/core";
import { Browser } from "@capacitor/browser";

const ExternalBrowser = registerPlugin("ExternalBrowser");

export async function openExternalBrowser(url) {
  if (Capacitor.isNativePlatform()) {
    try {
      // Prefer the device browser so the Alloyal session remains outside the app.
      await ExternalBrowser.open({ url });
    } catch (error) {
      // Keep the SmartLink usable when a locally registered bridge is unavailable.
      await Browser.open({ url });
    }
    return;
  }

  window.location.assign(url);
}
